<template>
  <div ref="loadMore">
    <slot />
  </div>
</template>

<script lang="ts">
import { ref, toRefs, watch, defineComponent, onUnmounted } from 'vue';
import { useScrollLoadMore } from '@cpc/comment-sdk-core';

export default defineComponent({
  name: 'ScrollLoadMore',
  props: {
    distance: {
      type: Number,
      required: false,
      default: 0.2,
    },
  },

  emits: ['update:loadMore'],

  setup(props, { emit }) {
    const loadMore = ref(null);
    const { distance } = toRefs(props);
    const { shouldLoad, stopLoad } = useScrollLoadMore(loadMore, {
      distance,
      lazyLoadPercent: 70,
    });

    // 组件被销毁就移除掉滚动事件
    onUnmounted(() => {
      stopLoad()
    })

    watch(shouldLoad, (value) => {
      if (value) {
        emit('update:loadMore');
      }
    });

    return {
      shouldLoad,
      loadMore,
    };
  },
});
</script>
